import { render, staticRenderFns } from "./fccAgenda.vue?vue&type=template&id=4076e6c8"
import script from "./fccAgenda.vue?vue&type=script&lang=js"
export * from "./fccAgenda.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports